var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo/greens"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.2345428,245.418068 C77.2345428,240.539374 65.3938397,237.464212 56.8999609,237.464212 L56.8999609,41.7308789 L56.8999609,41.7308789 C144.881139,22.0379781 191.356599,11.7516077 196.326341,10.8717675 C203.780953,9.55200718 214.469911,13.0645314 208.6132,14.8716541 C172.820408,25.9157315 129.027522,36.8312619 77.2345428,47.6182452 L77.2345428,245.418068 L77.2345428,245.418068 Z",
    id: "Combined-Shape",
    fill: "#127475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2345428,134.007895 C160.359037,114.949265 204.714202,103.397844 210.300039,99.3536324 C210.300039,99.3536324 210.300039,113.624957 210.300039,117.141042 C210.300039,119.399731 165.944874,131.564956 77.2345428,153.636715 L77.2345428,134.007895 Z",
    id: "Path-7",
    fill: "#0E9594"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9fd7dcf8.svg";
export { ForwardRef as ReactComponent };